import { render, staticRenderFns } from "./NotififyMemberModal.vue?vue&type=template&id=112df07e"
import script from "./NotififyMemberModal.vue?vue&type=script&lang=js"
export * from "./NotififyMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports